// src/pages/TownSelectPage.js
import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { getTowns, getCounties } from '../lib/db';
import { useAuth } from '../lib/AuthContext';
import { setUserTown } from '../lib/db';
import toast from 'react-hot-toast';

const TownSelectPage = () => {
  const navigate = useNavigate();
  const { countyId } = useParams();
  const { user } = useAuth();
  const [towns, setTowns] = useState([]);
  const [countyName, setCountyName] = useState(null);
  const [selected, setSelected] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getTowns(countyId).then(t => { setTowns(t); setLoading(false); });
    getCounties().then(counties => {
      const match = counties.find(c => c.id === countyId);
      setCountyName(match?.name || null);
    });
  }, [countyId]);

  const fallback = [
    { id: 'loughrea', name: 'Loughrea', population: '5,600', countyId: 'galway', status: 'live' },
    { id: 'tuam', name: 'Tuam', population: '8,900', countyId: 'galway', status: 'soon' },
    { id: 'ballinasloe', name: 'Ballinasloe', population: '6,700', countyId: 'galway', status: 'soon' },
    { id: 'portumna', name: 'Portumna', population: '1,200', countyId: 'galway', status: 'soon' },
  ];
  const display = towns.length > 0 ? towns : fallback;
  const liveTown = display.find(t => t.status === 'live');
  const sel = selected || liveTown?.id;

  const handleConfirm = async () => {
    if (!sel) return;
    localStorage.setItem('gather-town-id', sel);
    localStorage.setItem('gather-county-id', countyId);
    if (user) await setUserTown(user.uid, sel, countyId);
    navigate('/');
  };

  const selTown = display.find(t => t.id === sel);

  return (
    <div style={{ background: 'var(--cream)', minHeight: '100vh', paddingBottom: 100 }}>
      <div style={{ padding: '52px 20px 0' }}>
        <button style={{ display: 'flex', alignItems: 'center', gap: 8, background: 'none', border: 'none', cursor: 'pointer', marginBottom: 12 }} onClick={() => navigate('/county')}>
          <div style={{ width: 34, height: 34, background: 'var(--white)', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', boxShadow: 'var(--shadow-sm)', color: 'var(--sage-dark)' }}>←</div>
          <span style={{ fontSize: 13, color: 'var(--muted)', fontWeight: 600 }}>{countyName || (countyId ? countyId.charAt(0).toUpperCase() + countyId.slice(1) : 'Back')}</span>
        </button>
        <h1 style={{ fontSize: 28, fontWeight: 800, color: 'var(--ink)', marginBottom: 4, letterSpacing: '-0.3px' }}>Pick your town</h1>
        <p style={{ fontSize: 14, color: 'var(--muted)', fontWeight: 500, marginBottom: 16 }}>This becomes your default — change it any time</p>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10, padding: '0 18px' }}>
        {display.map(town => (
          <div key={town.id} onClick={() => town.status === 'live' && setSelected(town.id)}
            style={{
              background: sel === town.id ? 'var(--sage-pale)' : 'var(--white)',
              border: `2px solid ${sel === town.id ? 'var(--sage-deep)' : 'transparent'}`,
              borderRadius: 20, padding: '18px 16px', cursor: town.status === 'live' ? 'pointer' : 'default',
              boxShadow: 'var(--shadow-sm)', opacity: town.status === 'live' ? 1 : 0.7,
            }}>
            <div style={{ fontSize: 28, marginBottom: 10 }}>{'🏘️⛪🌿🏞️'.split('').filter((_,i) => i%2===0)[display.indexOf(town)] || '🏘️'}</div>
            <div style={{ fontSize: 17, fontWeight: 800, color: 'var(--ink)', marginBottom: 3 }}>{town.name}</div>
            <div style={{ fontSize: 12, color: 'var(--muted)', fontWeight: 500, marginBottom: 8 }}>{town.population || '—'} people</div>
            {town.status === 'live'
              ? <span style={{ background: 'var(--sage-deep)', color: 'white', fontSize: 10, fontWeight: 700, padding: '3px 9px', borderRadius: 100 }}>● Live now</span>
              : <span style={{ background: '#EEEEE8', color: 'var(--muted)', fontSize: 10, fontWeight: 600, padding: '3px 9px', borderRadius: 100 }}>Coming soon</span>
            }
          </div>
        ))}
      </div>

      <div style={{ position: 'fixed', bottom: 0, left: '50%', transform: 'translateX(-50%)', width: '100%', maxWidth: 430, padding: '13px 18px 26px', background: 'var(--white)', borderTop: '1.5px solid var(--border)', zIndex: 100 }}>
        <button onClick={handleConfirm} style={{ width: '100%', background: 'var(--sage-deep)', color: 'white', border: 'none', padding: 17, borderRadius: 16, fontSize: 16, fontWeight: 700, fontFamily: 'Nunito, sans-serif', cursor: 'pointer' }}>
          See what's on in {selTown?.name || 'Loughrea'} →
        </button>
      </div>
    </div>
  );
};

export default TownSelectPage;
